import React from 'react';
import UserDataSection from './UserDataSection';
import SizingSection from './SizingSection';
import SignatureSection from './SignatureSection';
import LegalFooter from './LegalFooter';
import FormHeader from './FormHeader';

function FormPage({config, formData, updateFormData, updateInterestedName, saveDocument, usersWithGroups, isEditing, cancelEdit}) {
  const handleSave = () => {
    // Validar que el nombre del cliente esté configurado
    if (!config.clientName || config.clientName.trim() === '') {
      alert('Por favor, configure el nombre del cliente en la sección de Configuración antes de guardar documentos.');
      return;
    }
    const docId = saveDocument();
    if (isEditing) {
      alert(`Documento actualizado con ID: ${docId}`);
    } else {
      alert(`Documento guardado con ID: ${docId}`);
    }
  };

  return (
    <div className="space-y-3 sm:space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-3 sm:p-6 space-y-4 sm:space-y-6">
        <FormHeader config={config} />
        {isEditing && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-amber-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium text-amber-800">Modo de edición: Estás modificando un documento existente</span>
            </div>
          </div>
        )}
        {!config.clientName && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-red-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium text-red-800">
                El nombre del cliente no está configurado. Ve a Configuración para configurarlo antes de guardar documentos.
              </span>
            </div>
          </div>
        )}
        <UserDataSection 
          formData={formData} 
          updateFormData={updateFormData} 
          usersWithGroups={usersWithGroups} 
        />
        <SizingSection 
          config={config} 
          formData={formData} 
          updateFormData={updateFormData} 
        />
        <SignatureSection 
          config={config} 
          formData={formData} 
          updateFormData={updateFormData} 
          updateInterestedName={updateInterestedName} 
          usersWithGroups={usersWithGroups} 
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
        <button 
          onClick={handleSave} 
          disabled={!config.clientName}
          className={`flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-colors text-sm ${
            config.clientName 
              ? 'bg-blue-600 text-white hover:bg-blue-700' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {isEditing ? 'Actualizar documento' : 'Guardar documento'}
        </button>
        {isEditing && (
          <button 
            onClick={cancelEdit}
            className="flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors text-sm"
          >
            Cancelar edición
          </button>
        )}
      </div>
      <LegalFooter />
    </div>
  );
}

export default FormPage;